// TinyMCE 6 settings for email wording. Keeps links exactly as typed so
// placeholders like {billing_link} survive, and loads the link, list and HTML
// plugins (TinyMCE 6 ignores the older plugin list in TinymceEditor).
export const EMAIL_EDITOR_INIT = {
  menubar: false,
  convert_urls: false,
  plugins: "link lists autolink code",
  toolbar:
    "undo redo | blocks | bold italic underline forecolor | " +
    "bullist numlist | link | alignleft aligncenter alignright | removeformat code",
  block_formats: "Paragraph=p; Heading=h2; Small heading=h3",
  statusbar: false,
  content_style:
    "body { font-family: Arial, Helvetica, sans-serif; font-size: 14px; color: #333; }",
};
